import React from 'react';

import { jsx } from '@compiled/react';
import { graphql, useFragment } from 'react-relay';
import { Box, xcss } from '@atlaskit/primitives';
import { ElementName } from '@atlaskit/smart-card';
import type { AtlasProjectGroupHeader$key } from '@atlassian/jira-relay/src/__generated__/AtlasProjectGroupHeader.graphql';
import { useIntl } from '@atlassian/jira-intl';
import { SimpleInlineSmartLink } from '@atlassian/jira-issue-field-atlas-project-common/src/ui/atlas-project-smart-link/inline-smart-llink/index.tsx';
import { useProjectUrlConstructor } from '@atlassian/jira-issue-field-atlas-project-common/src/util/index.tsx';
import messages from './messages.tsx';

export type Props = {
	atlasProjectGroupHeader: AtlasProjectGroupHeader$key | null;
};

export const AtlasProjectGroupHeader = ({ atlasProjectGroupHeader }: Props) => {
	const data = useFragment<AtlasProjectGroupHeader$key>(
		graphql`
			fragment AtlasProjectGroupHeader on JiraJqlTownsquareProjectFieldValue {
				project {
					id
					key
					privateProject
					hasPermission
				}
			}
		`,
		atlasProjectGroupHeader,
	);

	const { formatMessage } = useIntl();
	const constructAtlasProjectUrl = useProjectUrlConstructor();

	if (data?.project) {
		const url = constructAtlasProjectUrl({
			ari: data?.project?.id ?? '',
			projectKey: data?.project?.key ?? '',
		});

		return (
			<SimpleInlineSmartLink
				url={url}
				metadata={[{ name: ElementName.State }]}
				projectAri={data?.project?.id ?? ''}
				isPrivate={data?.project?.privateProject ?? false}
				initialHasNoAccess={data?.project?.hasPermission === false}
			/>
		);
	}

	return (
		<Box xcss={atlasProjectTextStyles}>{formatMessage(messages.noAtlasProjectDisplayName)}</Box>
	);
};

const atlasProjectTextStyles = xcss({
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
});
